module.exports = __webpack_public_path__ + "img/19.a305e445.jpg";